import { APIClient } from '@frontend/api-utils';
import { FunctionalityTemplate } from '@frontend/functionality/types';

export class FunctionalityTemplateClient extends APIClient {
    public static readonly endpoint = '/functionality-api/v1';

    public static async fetchApplicationTemplates(): Promise<FunctionalityTemplate> {
        const response = await this.fetch(`${this.endpoint}/application-templates`);
        return await this.handleResponse<FunctionalityTemplate>(response);
    }
}
